import { render, staticRenderFns } from "./addPopup.vue?vue&type=template&id=8472c416"
import script from "./addPopup.vue?vue&type=script&lang=js"
export * from "./addPopup.vue?vue&type=script&lang=js"
import style0 from "./addPopup.vue?vue&type=style&index=0&id=8472c416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports